import { IconWrapper } from '../runtime';
export default IconWrapper('play-volleyball', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M29 14C31.7614 14 34 11.7614 34 9C34 6.23858 31.7614 4 29 4C26.2386 4 24 6.23858 24 9C24 11.7614 26.2386 14 29 14Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2"
    }
  }), h("path", {
    "attrs": {
      "d": "M41 24C42.6569 24 44 22.6569 44 21C44 19.3431 42.6569 18 41 18C39.3431 18 38 19.3431 38 21C38 22.6569 39.3431 24 41 24Z",
      "fill": props.colors[0]
    }
  }), h("path", {
    "attrs": {
      "d": "M16 24L13.73 35.26C13.52 36.57 12.12 37.31 10.92 36.76L4 34",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M38 30L23.76 19.07C22.99 18.5 21.93 18.56 21.22 19.2L16.38 23.63C15.91 24.06 15.95 24.8 16.47 25.18L26 32.15C26.72 32.68 27.01 33.63 26.69 34.47L23.12 44",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]);
});